import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material';
import getSymbolFromCurrency from 'currency-symbol-map';
import React from 'react';

const RetractionFeesRecapModal = ({
  isFromDrawwer,
  productsAmount,
  retractionType,
  _calculMethod,
  retractFeeAmount,
  refundAmount,
  partialRefundAmount,
  currencyCode,
  orderReference,
  packageCount,
  ticketReference,
  carrierOption,
  orderAmount,
  isOpen,
  onClose,
}) => {
  const getRecapText = () => {
    return `${
      !isFromDrawwer ? `Ticket : ${ticketReference}\n` : ''
    }Commande : ${orderReference}
  Demande : ${retractionType === 'total' ? 'Totale' : 'Partielle'}
  Montant de la commande : ${orderAmount}${getSymbolFromCurrency(currencyCode)}
  ${
    productsAmount
      ? `Montant total des produits rétractés : ${productsAmount}${getSymbolFromCurrency(
          currencyCode
        )}\n`
      : ''
  }
  Frais de rétractations : ${retractFeeAmount}${getSymbolFromCurrency(
    currencyCode
  )}
  Remboursement à effectuer : ${refundAmount}${getSymbolFromCurrency(
    currencyCode
  )}
  Si deuxième commande (50% des frais à rembourser) : ${partialRefundAmount}${getSymbolFromCurrency(
    currencyCode
  )}
  Produits à rétracter : ${packageCount} Colis`;
  };

  const handleCopy = () => {
    navigator.clipboard.writeText(getRecapText());
  };

  return (
    <Dialog open={isOpen} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Récapitulatif des frais de rétractation</DialogTitle>
      <DialogContent>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, my: 2 }}>
          {!isFromDrawwer && (
            <Typography>
              <strong>Ticket :</strong> {ticketReference}
            </Typography>
          )}
          <Typography>
            <strong>Commande :</strong> {orderReference}
          </Typography>
          <Typography>
            <strong>Demande :</strong>{' '}
            {retractionType === 'total' ? 'Totale' : 'Partielle'}
          </Typography>
          <Typography>
            <strong>Montant de la commande :</strong> {orderAmount}
            {getSymbolFromCurrency(currencyCode)}
          </Typography>
          {productsAmount && (
            <Typography>
              <strong>Montant total des produits rétractés :</strong>{' '}
              {productsAmount}
              {getSymbolFromCurrency(currencyCode)}
            </Typography>
          )}
          <Typography>
            <strong>Frais de rétractations :</strong> {retractFeeAmount}
            {getSymbolFromCurrency(currencyCode)}
          </Typography>
          <Typography>
            <strong>Remboursement à effectuer :</strong> {refundAmount}
            {getSymbolFromCurrency(currencyCode)}
          </Typography>
          <Typography>
            <strong>Si deuxième commande (50% des frais à rembourser) :</strong>{' '}
            {partialRefundAmount}
            {getSymbolFromCurrency(currencyCode)}
          </Typography>
          <Typography>
            <strong>Produits à rétracter :</strong> {packageCount} Colis
          </Typography>
          <Typography>
            <strong>Option de transport disponible :</strong> {carrierOption}
          </Typography>
        </Box>
      </DialogContent>
      <DialogActions
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
        }}
      >
        <Button onClick={onClose}>Fermer</Button>
        <Button
          onClick={handleCopy}
          startIcon={<ContentCopyIcon />}
          variant="contained"
          color="primary"
        >
          Copier
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default RetractionFeesRecapModal;
